module.exports = "<backups-page></backups-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appRoutes/backups.html
// module id = 1775
// module chunks = 0